import React from 'react';
import { Link } from 'react-router-dom';
import '../Layout.css';

export default function AdminLinks({ mobile = false }) {
  const navClass = mobile ? 'mobile-nav-link' : 'nav-link';

  return (
    <>
      <Link to="/users" className={`${navClass} admin-link`}>
        <span className="material-symbols-rounded group-icon">group</span>
        Users
      </Link>
      <Link to="/api-tokens" className={`${navClass} admin-link`}>
        <span className="material-symbols-rounded key-icon">key</span>
        API Tokens
      </Link>
    </>
  );
}
